export default __webpack_public_path__ + "static/1_KV iMedical Card Elite 390px 430px EN-cb63790de952de45a71b5415406b1be2.jpg";